import ScrollableCard from './ScrollableCard';

export default ScrollableCard;
